import http from '@src/utils/request';
/**
 * 获取数据
 * @param {*} params 查询参数
 * @returns
 */
export function getDataApi(params) {
  return http.get('/api/v4/his/studyJson', { params });
}
